/**
 * A components flow has no saved version between creation and the first
 * generation's commit (and permanently if that generation aborts/crashes).
 * Screen mutations route through `createFlowVersion`, which throws this error
 * when the flow has no version yet. It is an expected, user-recoverable state
 * — surfaced as a friendly toast rather than an unhandled rejection
 * (Sentry BANANI-APP-17K7).
 */
export const FLOW_NOT_READY_MESSAGE =
  'This project is still being set up — please try again in a moment.';

// Matched by message equality on the shared FLOW_NOT_READY_MESSAGE constant:
// the server (createFlowVersion) and this client detector import the SAME
// constant, so the strings can't drift. We deliberately do NOT also gate on
// `data.code === 'CONFLICT'` — that code is reused by other expected errors
// (e.g. createFlow's duplicate-id guard), so it would over-match.
export function isFlowNotReadyError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message === FLOW_NOT_READY_MESSAGE
  );
}
